import type { ReactNode } from 'react';
import { CopyableCell } from '@/shared/ui';

/** Ячейка с кнопкой копирования показанного значения; без текста кнопка не рисуется */
export const renderCopyableCell = (text: string | null, content: ReactNode) => (
  <CopyableCell text={text}>{content}</CopyableCell>
);
